module.exports = __webpack_public_path__ + "img/7.1.dbf2c814.jpg";